import { useRef, useState } from 'react';
import { useMotion } from '@/hooks/useEditorialMotion';
import { serviceGroups, serviceTiers } from '@/mocks/home';

export default function Services() {
  const [tier, setTier] = useState(0);
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  return (
    <section ref={ref} id="services" className="bg-background-100 border-t border-background-300 py-16 md:py-28">
      <div className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-10">
        <div className="lg:col-span-4">
          <div data-group className="lg:sticky lg:top-28">
            <h2 data-m="title" className="font-heading font-semibold tracking-[-0.02em] leading-[1.05] text-[36px] md:text-[52px] text-foreground-950">Services &amp; Pricing</h2>
            <p data-m="text" data-at="0.18" className="mt-6 max-w-sm text-[16px] leading-relaxed text-foreground-700">Starting prices by stylist level. Final price depends on hair length and is confirmed at consultation.</p>
            <div className="mt-10 inline-flex p-1 rounded-full bg-background-50 flex-wrap">
              {serviceTiers.map((t, i) => (
                <button key={t} type="button" onClick={() => setTier(i)} className={`px-4 py-2 rounded-full text-[13px] whitespace-nowrap cursor-pointer transition-colors ${tier === i ? 'bg-foreground-950 text-background-100' : 'text-foreground-700 hover:text-foreground-950'}`}>{t}</button>
              ))}
            </div>
          </div>
        </div>

        <div className="lg:col-span-8 flex flex-col gap-12">
          {serviceGroups.map((g) => (
            <div key={g.id} data-group>
              <div className="relative flex items-baseline justify-between gap-4 pb-3">
                <h3 data-m="left" className="font-heading font-semibold text-[20px] md:text-[24px] text-foreground-950">{g.title}</h3>
                <span className="text-[13px] text-foreground-600 whitespace-nowrap">{serviceTiers[tier]}</span>
                <span data-m="line" data-at="0.15" aria-hidden="true" className="absolute left-0 right-0 bottom-0 h-px bg-foreground-950"></span>
              </div>
              <ul>
                {g.items.map((s) => (
                  <li key={s.name} data-m="row" data-at="0.3" className="grid grid-cols-[1fr_auto] md:grid-cols-[1fr_96px_72px] gap-x-6 items-center min-h-[64px] py-4 border-b border-background-300">
                    <div>
                      <p className="text-[16px] font-semibold text-foreground-950">{s.name}</p>
                      <p className="mt-0.5 text-[14px] text-foreground-600">{s.desc}<span className="md:hidden"> · {s.time}</span></p>
                    </div>
                    <p className="hidden md:block text-[14px] text-foreground-600 whitespace-nowrap">{s.time}</p>
                    <p className="text-[16px] font-semibold text-foreground-950 text-right whitespace-nowrap">{s.prices[tier]}</p>
                  </li>
                ))}
              </ul>
              <p className="mt-3 text-[13px] text-foreground-600">{g.note}</p>
            </div>
          ))}
          <p className="text-[13px] text-foreground-600">Prices shown are placeholders.</p>
        </div>
      </div>
    </section>
  );
}